
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.802 18.7c-.6 5.6-4.4 10.5-10.5 10.2-5.8-.3-9.6-5.4-9.6-10.9 0-5.7 4.1-11 10.1-11 5.9 0 9.4 4.9 10 10.1.1.3.1.5.1.8 0 .3 0 .6-.1.8zm-1.3-.7c-.6 10.1-17.4 10.2-17.4 0s16.8-10.2 17.4 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.102 31.7c9.8-6.2 20.9 1.2 22.3 11.7.3 2.4.6 6.4-1.2 8.3-1.454 1.454-3.888 1.342-5.982 1.245a31.598 31.598 0 00-1.418-.045h-12.8c-.37 0-.751.012-1.138.024-2.125.066-4.408.137-5.762-1.724-1.418-1.892-1.138-5.036-.934-7.317l.034-.383c.4-4.8 2.8-9.2 6.9-11.8zm8.349 18.11c1.633-.055 3.259-.11 4.851-.11h.414c4.063.007 8.063.013 7.386-5.5-1.3-10.1-13.5-15.1-21.6-8.8-4.3 3.3-8.5 13.4-.8 14.3 3.14.334 6.46.222 9.749.11z"}})])
          )
        }
      }
    